/**
 * MODULES - custom modal
 * @author PLEJ
 */

const modal = (() => {
  let activeModal = null;
  const html = document.querySelector('html');

  const init = () => {
    const popup = document.querySelector('[data-popup-modal]');
    const triggers = document.querySelectorAll('[data-custom-modal]');
    const close = document.querySelectorAll('[data-close-modal]');
    triggers.forEach(each => (each.onclick = initEvent));
    close.forEach(each => (each.onclick = closeModal));

    initPopup(popup);
  };

  const initEvent = (element) => {
    let target = element.target;
    let selector = target.dataset.customModal;

    openModal(document.querySelector( selector ));
  };

  const initPopup = (popup) => {
    if(!popup) return;

    setTimeout(function(){
      openModal(popup);
    }, 1000);
  };

  const openModal = ( modal ) => {
    if(!modal) return;

    activeModal = modal;

    modal.classList.add("active");
    html.classList.add("modalOpened");

    setTimeout( function() {
      modal.classList.add("animated");
    }, 200 );
  };

  const closeModal = ( ) => {
    if (activeModal) {
      activeModal.classList.remove("active", "animated");
      html.classList.remove("modalOpened");
      activeModal = null;
    }
  };

  return {
    init,
    closeModal,
    openModal,
  };
})();

export {modal}